import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MainViewComponent} from "./main-view.component";
import {Routing} from "./main-view.routes";
import {LoaderComponent} from "../loader/loader.component";
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GetComponent} from './get/get.component';
import {PutComponent} from './put/put.component';
import {PostComponent} from './post/post.component';
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {FieldInputComponent} from '../input/field-input.component';
import {ArrayInputComponent} from '../input/array-input.component';
import {RowFilterPipe} from './row-filter.pipe';
import {OnboardingRequestsComponent} from './onboarding-requests/onboarding-requests.component';
import {TransitTimeOnboardingComponent} from './onboarding-requests/transit-time-onboarding/transit-time-onboarding.component';
import {PreviousRequestsComponent} from './previous-requests/previous-requests.component';
import {UpdateRequestsComponent} from './update-requests/update-requests.component';
import {PadTransitTimeComponent} from './update-requests/pad-transit-time/pad-transit-time.component';
import {UpdateTransitTimeComponent} from './update-requests/update-transit-time/update-transit-time.component';
import { UpdateTransitTimeS3Component } from './update-requests/update-transit-time-s3/update-transit-time-s3.component';
import {HelpComponent} from './help/help.component';
import {ConfigureTransitTimeRequestsComponent} from './configure-transit-time-requests/configure-transit-time-requests.component';
import {InfoComponent} from "./info/info.component";
import {ChangeActiveVersionRequestsComponent} from "./change-active-version-requests/change-active-version-requests.component";
import {PopoverComponent} from "../popover/popover.component";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TableComponent} from "../table/table.component";
import {PendingApprovalRequestsComponent} from "./pending-approval-requests/pending-approval-requests.component";
import {MyRequestsComponent} from "./my-requests/my-requests.component";
import {UpdateTransitTimeOverridesComponent} from "./update-transit-time-overrides/update-transit-time-overrides.component";
import {UpdateValidationThresholdComponent} from "./update-validation-threshold/update-validation-threshold.component";
import {QuartzCronModule} from "@sbzen/ng-cron";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {CronComponent} from './update-validation-threshold/cron/cron.component';
import {MatDialogModule} from '@angular/material/dialog';
import {CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from "@angular/core";
import {DialogService} from "../../services/dialog.service";
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import {MatSliderModule} from "@angular/material/slider";
import {MatSelectModule} from "@angular/material/select";
import { EditThresholdComponent } from './update-validation-threshold/edit-threshold/edit-threshold.component';
import { AddThresholdConfirmDialogComponent } from './update-validation-threshold/add-threshold-confirm-dialog/add-threshold-confirm-dialog.component';
import { DeleteThresholdConfirmDialogComponent } from './update-validation-threshold/delete-threshold-confirm-dialog/delete-threshold-confirm-dialog.component';
import { RemoveLaneTransitTimeUpdateComponent } from './update-requests/remove-lane-transit-time-update/remove-lane-transit-time-update.component';
import { RequestPermissionsComponent } from './request-permissions/request-permissions.component';
import { ManageUserPermissionsComponent } from './manage-permissions-wrapper/manage-user-permissions/manage-user-permissions.component';
import { ManagePermissionsWrapperComponent } from './manage-permissions-wrapper/manage-permissions-wrapper.component';
import { RejectResourcePermissionsDialogComponent } from './manage-permissions-wrapper/reject-resource-permissions-dialog/reject-resource-permissions-dialog.component';
import { ViewUpdatedUserPermissionsComponent } from './manage-permissions-wrapper/view-updated-user-permissions/view-updated-user-permissions.component';
import { CreateResourceComponent } from './manage-permissions-wrapper/create-resource/create-resource.component'
import { MultiSelectInputComponent } from '../input/multi-select-input/multi-select-input.component';
import { TransitTimeConfigurationComponent } from './transit-time-configuration/transit-time-configuration.component';
import { EditTransitTimeConfigComponent } from './transit-time-configuration/edit-transit-time-config/edit-transit-time-config.component';


@NgModule({
  imports: [
    CommonModule,
    Routing,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgbModule,
    QuartzCronModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    NoopAnimationsModule,
    MatDialogModule,
    MatSliderModule,
    MatSelectModule
  ],
  declarations: [MainViewComponent, MyRequestsComponent, PendingApprovalRequestsComponent, UpdateTransitTimeOverridesComponent, LoaderComponent, GetComponent, PutComponent, PostComponent, FieldInputComponent, ArrayInputComponent, RowFilterPipe, OnboardingRequestsComponent, TransitTimeOnboardingComponent, PreviousRequestsComponent, UpdateRequestsComponent, PadTransitTimeComponent, InfoComponent, UpdateTransitTimeComponent, HelpComponent, ConfigureTransitTimeRequestsComponent, ChangeActiveVersionRequestsComponent, PopoverComponent, TableComponent, UpdateTransitTimeS3Component, UpdateValidationThresholdComponent, CronComponent, ConfirmDialogComponent, EditThresholdComponent, AddThresholdConfirmDialogComponent, DeleteThresholdConfirmDialogComponent, RemoveLaneTransitTimeUpdateComponent, RequestPermissionsComponent, ManageUserPermissionsComponent, ManagePermissionsWrapperComponent, RejectResourcePermissionsDialogComponent, ViewUpdatedUserPermissionsComponent, CreateResourceComponent, MultiSelectInputComponent, TransitTimeConfigurationComponent, EditTransitTimeConfigComponent],
  providers: [DialogService],
  entryComponents: [
    OnboardingRequestsComponent,
    TransitTimeOnboardingComponent,
    UpdateRequestsComponent,
    PadTransitTimeComponent,
    UpdateTransitTimeComponent,
    HelpComponent,
    InfoComponent,
    ChangeActiveVersionRequestsComponent,
    PendingApprovalRequestsComponent,
    UpdateTransitTimeOverridesComponent,
    UpdateTransitTimeS3Component,
    UpdateValidationThresholdComponent,
    CronComponent,
    ConfirmDialogComponent,
    EditThresholdComponent,
    AddThresholdConfirmDialogComponent,
    DeleteThresholdConfirmDialogComponent,
    RemoveLaneTransitTimeUpdateComponent,
    RejectResourcePermissionsDialogComponent,
    EditTransitTimeConfigComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class MainViewModule {
}
